import { Button, Group, Text } from "@mantine/core";
import { ConfirmAndExecutePanel, EntityClientAction, openEntityForm } from "@mcurros2/microm";
import { IconAlertCircle } from "@tabler/icons-react";
import { SolicitudesRuteo } from "./SolicitudesRuteo";

export const ACTEditarRuta: EntityClientAction = {
    name: 'ACTEditarRuta',
    label: 'Editar Ruta',
    title: <Text fw={700}>Editar ruta</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    views: ['soru_brwDisponibleEnRutas'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const abort_controller = new AbortController();

        await modal.open({
            modalProps: {
                title: <Text fw="700">Solicitud de modificación de ruta</Text>
            },
            focusOnClosed: element,
            content: <ConfirmAndExecutePanel
                content={<Text size="sm" mb="xs">Va a generar una solicitud de modificación de ruta. ¿Está seguro?</Text>}
                operation="proc"
                onCancel={async () => {
                    abort_controller.abort();
                    await modal.close();
                    if (onClose) await onClose(false);
                }}
                onOK={
                    async () => {
                        // cast entity
                        const solicitudesRuteo = new SolicitudesRuteo(entity.API.client);
                        solicitudesRuteo.def.columns.c_personal_id.value = selectedKeys![0].c_personal_id as unknown as string || '';
                        const result = await solicitudesRuteo.API.addData();

                        if (result.Failed) {
                            await modal.open({
                                modalProps: {
                                    title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">ERROR</Text></Group>,
                                },
                                focusOnClosed: element,
                                content:
                                    <>
                                        <Text size="sm" mb="xs">
                                            {result.Results[0].Message}
                                        </Text>
                                        <Group mt="xs" position="right">
                                            <Button onClick={async () => await modal.close()}>Cerrar</Button>
                                        </Group>
                                    </>
                            });
                            return;
                        } else {
                            await modal.close();
                            await openEntityForm({
                                modals: modal,
                                handleModalClosed: async () => {
                                    if (solicitudesRuteo.def.columns.c_solicitudruteo_id.value) {
                                        try {
                                            // fire and forget and ignore any error
                                            solicitudesRuteo.API.executeProcess(solicitudesRuteo.def.procs.soru_EliminarNoModificada, { c_solicitudruteo_id: solicitudesRuteo.def.columns.c_solicitudruteo_id.value });
                                        }
                                        catch (error) {
                                            console.error(error);
                                        }
                                    }
                                },
                                formProps: {
                                    entity: solicitudesRuteo,
                                    initialFormMode: 'edit',
                                    getDataOnInit: true,
                                },
                                modalFormSize: 'fullscreen',
                                handleModalSaved: async () => { await modal.close(); if (onClose) await onClose(); },
                                handleModalCancel: async () => { await modal.close(); if (onClose) await onClose(); }
                            });
                        }
                    }
                }
            />

        });

        return false;
    }
}